import React from 'react';
import { Grid, TextField } from '@material-ui/core';
export const EntityTimeField = props => {
    var _a, _b;
    const { plugin, column, value, onChange } = props;
    const error = (_b = (_a = plugin.edit) === null || _a === void 0 ? void 0 : _a.validateError) === null || _b === void 0 ? void 0 : _b.call(_a, column, value);
    return (React.createElement(TextField, { fullWidth: true, 
        // disabled={disabled}
        type: 'time', error: !!error, size: 'small', variant: 'outlined', value: value || undefined, label: 'Pick a time', helperText: error || '', InputLabelProps: { shrink: true }, onChange: event => {
            onChange === null || onChange === void 0 ? void 0 : onChange(event.target.value || undefined);
        } }));
};
export const EntitySampleTimeConfigurator = props => {
    const { column, config, disabled, validate, onChange } = props;
    const errors = (validate === null || validate === void 0 ? void 0 : validate(config, column)) || {};
    const renderInput = (type) => {
        var _a;
        const isMin = type === 'min';
        return (React.createElement(TextField, { fullWidth: true, type: 'time', size: 'small', variant: 'outlined', disabled: disabled, error: !!errors[type], label: isMin ? 'Min' : 'Max', defaultValue: (_a = config[type]) !== null && _a !== void 0 ? _a : '', InputLabelProps: { shrink: true }, helperText: errors[type] || `Set the ${isMin ? 'minimum' : 'maximum'} time range`, onChange: event => {
                onChange === null || onChange === void 0 ? void 0 : onChange({ [type]: event.target.value || undefined });
            } }));
    };
    return (React.createElement(Grid, { container: true, spacing: 2 },
        React.createElement(Grid, { item: true, xs: 12, sm: 6 }, renderInput('min')),
        React.createElement(Grid, { item: true, xs: 12, sm: 6 }, renderInput('max'))));
};
export const EntityTimePlugin = {
    type: 'time',
    edit: {
        field: EntityTimeField
    },
    sampleData: {
        configurator: EntitySampleTimeConfigurator,
        defaultValue: () => ({ min: '00:00', max: '23:59' }),
        validate: config => {
            const { min = '', max = '' } = config;
            const minError = !min ? 'Min time is required.' : undefined;
            const maxError = !max
                ? 'Max time is required.'
                : min && +min.split(':').join('') > +max.split(':').join('')
                    ? 'Max time is less than Min time.'
                    : undefined;
            return minError || maxError
                ? { min: minError, max: maxError }
                : undefined;
        }
    }
};
//# sourceMappingURL=EntityTimePlugin.js.map